import React from 'react';
import { Dialog, DialogActions, Button, useMediaQuery, useTheme } from '@mui/material';
import RecebimentoOSContent from './RecebimentoOSContent';

export default function RecebimentoOSModal({ open, onClose, API, token }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth fullScreen={isMobile}>
      <RecebimentoOSContent open={open} API={API} token={token} />
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
}
